module.exports = __webpack_public_path__ + "static/media/appstore_badge.f008976d.png";